
/* ===================== Readme =====================

This file is a temporary container for the old <ProfileCalendarBtns>
component which was in a really weird place. The functionality
from <ProfileCalendarBtns> should be moved into here.

/* =============================================== */

// Core
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './styles.css';

// Components
import ProfileCalendarBtns from '../../../../components/profile/calendar-btns';
import CancelBtn from '../../../../components/CancelBtn';

export default class Actions extends Component {

    makeIcalLink()
    {
        return this.props.eventAttendance.ical;
    }

    makeAppleWalletLink()
    {
        return this.props.eventAttendance.passbook;
    }

    render() {

        return (
            <>
                <ProfileCalendarBtns ical={this.makeIcalLink()} passbook={this.makeAppleWalletLink()} event={this.props.event} {...this.props}></ProfileCalendarBtns>
                <CancelBtn {...this.props} />
            </>
        )
    }
}

Actions.propTypes = {
    event: PropTypes.object,
};

